import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../App';
export const getComponentS = (org_id?: number) => {
  let theQuery = '';
  if (org_id) {
    theQuery = `org_id=${org_id}`;
  }
  return axios.get(
    GetBackendUrlForGlobalFunctions() + `department/app-component?${theQuery}`
  );
};
export const AddAppComponent = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `department/app-component/create`,
    obj,
    { headers }
  );
};

export const EditAppComponent = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `department/app-component/update`,
    obj,
    { headers }
  );
};

export const DeleteAppComponent = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `department/app-component/delete`,
    obj,
    { headers }
  );
};
